import { ChartsResponse, Charts } from 'types/Meteorology/Agro/CultureIndex/Location/getCharts';

/* eslint-disable import/prefer-default-export */
export const transformGetCharts = (response: ChartsResponse): Charts[] => response.data as Charts[];
